import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ReducerInitialValueProps, initialValueProps } from "./home.type";

const initialState: ReducerInitialValueProps = {
  user: {
    email: "",
    firstName: "",
    lastName: "",
    profileImg: "",
    dob: "",
    token: "",
    uuid: "",
    hasSkippedProfileImg: false,
    isLoading: true,
  },
  hasUserExceededPlan: false,
  planMsg: "",
};

const homeSlice = createSlice({
  name: "home",
  initialState: initialState,
  reducers: {
    setUser: (state, action: PayloadAction<initialValueProps>) => {
      return { ...state, user: { ...state.user, ...action.payload } };
    },
    setHasUserExceededPlan: (state, action: PayloadAction<boolean>) => {
      return { ...state, hasUserExceededPlan: action.payload };
    },
    setPlanMsg: (state, action: PayloadAction<string>) => {
      return { ...state, planMsg: action.payload };
    },

    reset: () => initialState,
  },
  extraReducers: (builder) => {},
});

export const homeReducer = homeSlice.reducer;

export const homeActions = {
  ...homeSlice.actions,
};
